var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Actions, Effect, ofType } from '@ngrx/effects';
import { NotifyActionTypes } from './notify.actions';
import { map } from 'rxjs/operators';
import { NotifyService } from './notify.service';
var NotifyEffects = /** @class */ (function () {
    function NotifyEffects(actions$, notifyService) {
        var _this = this;
        this.actions$ = actions$;
        this.notifyService = notifyService;
        this.showError$ = this.actions$.pipe(ofType(NotifyActionTypes.ShowError), map(function (_) { return ({ code: _.payload.code, message: _.payload.message }); }), map(function (_) { return _this.notifyService.showError(_); }));
        this.snakNotify$ = this.actions$.pipe(ofType(NotifyActionTypes.SnackNotify), map(function (_) { return _.payload; }), map(function (_) { return _this.notifyService.snackNotify(_); }));
    }
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Object)
    ], NotifyEffects.prototype, "showError$", void 0);
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Object)
    ], NotifyEffects.prototype, "snakNotify$", void 0);
    return NotifyEffects;
}());
export { NotifyEffects };
